import { lazy } from 'react';

import { LayoutType, PageType } from '@shared/constants/constants';
import {
  ACTION_BACK_PATH,
  REFUNDS_ADD_REFUND_PATH,
  REFUNDS_PATH,
  REFUNDS_SELECT_INSTITUTION_PATH,
  REFUNDS_SELECT_PATIENT_PATH,
  REFUNDS_STATUS_PATH,
  REFUNDS_SUMMARY_PATH,
  REFUNDS_TERMS_AND_CONDITIONS_PATH,
} from '@shared/constants/paths';
import { SERVICE_CATALOG_CODE } from '@shared/constants/serviceCatalog';
import type { RouteConfig } from '@shared/types/common.types';

const RefundLandingPage = lazy(() => import('./pages/RefundLandingPage/RefundLandingPage'));
const SelectInstitutionsPage = lazy(() => import('./pages/SelectInstitutionsPage/SelectInstitutionsPage'));
const SelectPatientPage = lazy(() => import('./pages/SelectPatientPage/SelectPatientPage'));
const SelectRefundTypePage = lazy(() => import('./pages/SelectRefundTypePage/SelectRefundTypePage'));
const TermsAndConditionPage = lazy(() => import('./pages/TermsAndConditionPage/TermsAndConditionPage'));
const AddRefundPage = lazy(() => import('./pages/RefundSummaryPage/RefundSummaryPage'));
const RefundStatusPage = lazy(() => import('./pages/RefundStatusPage/RefundStatusPage'));

export const REFUNDS_ROUTES: RouteConfig[] = [
  {
    actionUrl: ACTION_BACK_PATH,
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE],
    component: () => <RefundLandingPage />,
    displayTitle: () => 'Refunds',
    pageType: PageType.PRIVATE,
    path: REFUNDS_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.refunds,
  },
  {
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE],
    component: () => <SelectInstitutionsPage />,
    displayTitle: () => 'Refunds',
    pageType: PageType.PRIVATE,
    path: REFUNDS_SELECT_INSTITUTION_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.refunds,
  },
  {
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE],
    component: () => <SelectPatientPage />,
    displayTitle: () => 'Refunds',
    pageType: PageType.PRIVATE,
    path: REFUNDS_SELECT_PATIENT_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.refunds,
  },
  {
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE],
    component: () => <SelectRefundTypePage />,
    displayTitle: () => 'Refunds',
    pageType: PageType.PRIVATE,
    path: REFUNDS_ADD_REFUND_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.refunds,
  },
  {
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE],
    component: () => <TermsAndConditionPage />,
    displayTitle: () => 'Terms and Conditions',
    pageType: PageType.PRIVATE,
    path: REFUNDS_TERMS_AND_CONDITIONS_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.refunds,
  },
  {
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE],
    component: () => <AddRefundPage />,
    displayTitle: () => 'Refunds',
    pageType: PageType.PRIVATE,
    path: REFUNDS_SUMMARY_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.refunds,
  },
  {
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE],
    component: () => <RefundStatusPage />,
    displayTitle: () => 'Refunds',
    pageType: PageType.PRIVATE,
    path: REFUNDS_STATUS_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.refunds,
  },
];
